export default __webpack_public_path__ + "static/media/gallery_02.04b6f410.jpg";